"use strict"

const _ = require('lodash')

function resolvePath(source, path) {
    let ret = source
    for (let i = 0; i < path.length; i++) {
        const prop = path[i]
        if (_.has(ret, prop)) {
            ret = ret[prop]
        } else {
            return null
        }
    }
    return ret
}

function ensurePath(source, path) {
    let ret = source
    for (let i = 0; i < path.length; i++) {
        const prop = path[i]
        if (!_.has(ret, prop)) {
            ret[prop] = {}
        }
        ret = ret[prop]
    }
}

function setInPath(source, path, value) {
    const scope = resolvePath(source, _.initial(path))
    if (scope !== null) {
        scope[_.last(path)] = value
    }
}

function filter(source, predicate, canEnterSubtreePredicate) {
    canEnterSubtreePredicate = canEnterSubtreePredicate || function () {
        return true
    }
    const ret = []
    const findInner = function (obj) {
        if (_.isNil(obj)) {
            return
        }

        if (predicate(obj)) {
            ret.push(obj)
        }

        if (!canEnterSubtreePredicate(obj)) {
            return
        }

        if (_.isPlainObject(obj) || _.isArray(obj)) {
            _.forEach(obj, function (value) {
                findInner(value)
            })
        }
    }

    findInner(source)
    return ret
}

function findPath(obj, predicate, path) {
    path = path || []

    if (predicate(obj)) {
        return path
    }

    let found = null
    if (_.isPlainObject(obj) || _.isArray(obj)) {
        _.forEach(obj, function (val, key) {
            found = findPath(obj[key], predicate, path.concat(key))
            if (found) {
                return false
            }
        })
    }

    return found
}

// Unlike _.cloneDeep, this has no protection against circular data structures
function cloneDeep(value, customizer) {
    if (_.isFunction(customizer)) {
        const customizerResult = customizer(value)
        if (!_.isUndefined(customizerResult)) {
            return customizerResult
        }
    }

    if (_.isDate(value)) {
        return new Date(+value)//copied lodash implementation
    }

    if (_.isFunction(value)) {
        return value
    }

    if (_.isArray(value)) {
        return _.map(value, v => cloneDeep(v, customizer))
    }

    if (_.isObject(value)) {
        return _.mapValues(value, v => cloneDeep(v, customizer))
    }

    return value
}

function isDifferent(a, b) {
    return !_.isEqual(a || null, b || null)
}

/**
 * does not change the original objects
 * the function clones only if there might be a change that will change the object
 * @param {Object} object the object to clone and merge to
 * @param {Object} source the object to compare to and merge into object
 * @param {function(String|Number|Boolean, String|Number|Boolean, String) -> boolean} shouldTakeSourceValue
 * gets the value of object at key, the value of source at key and the key.
 * the function is called only on primitive fields, should return true if you want to take the source value
 * @returns {Object}
 */
function cloneAndConditionalMergeOfFields(object, source, shouldTakeSourceValue){
    if (!_.isObject(object)){
        return object
    }
    const result = _.clone(object)


    _.forOwn(source, function(val, key){
        if (typeof val !== 'object' && shouldTakeSourceValue(object[key], source[key], key)){
            result[key] = source[key]
            return
        }
        if (!object[key]){
            return
        }

        if (_.isPlainObject(val)){
            result[key] = cloneAndConditionalMergeOfFields(object[key], val, shouldTakeSourceValue)
        } else if (_.isArray(val)){
            result[key] = _.compact( _.map(val, function(item, index){
                if (!object[key][index]){
                    return undefined
                }
                return cloneAndConditionalMergeOfFields(object[key][index], item, shouldTakeSourceValue)
            }) )
            _.defaults(result[key], object[key])
        }
    })
    return result
}

module.exports = {
    resolvePath,
    ensurePath,
    setInPath,
    filter,
    findPath,
    cloneDeep,
    isDifferent,
    cloneAndConditionalMergeOfFields
}



// WEBPACK FOOTER //
// ./src/coreUtils/src/main/core/objectUtils.js